import React from 'react'

import * as styles from './Loader.module.css'

export const Loader: React.FC = () => <span className={styles.loader}></span>
